/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
@property --tw-animation-delay {
  syntax: "*";
  inherits: false;
  initial-value: 0s;
}
@property --tw-animation-direction {
  syntax: "*";
  inherits: false;
  initial-value: normal;
}
@property --tw-animation-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-animation-fill-mode {
  syntax: "*";
  inherits: false;
  initial-value: none;
}
@property --tw-animation-iteration-count {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-enter-blur {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-enter-opacity {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-enter-rotate {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-enter-scale {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-enter-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-enter-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-blur {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-opacity {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-exit-rotate {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-scale {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-exit-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
:root {
  --background: oklch(1 0 0);
  --foreground: oklch(0.145 0 0);
  --card: oklch(1 0 0);
  --card-foreground: oklch(0.145 0 0);
  --popover: oklch(1 0 0);
  --popover-foreground: oklch(0.145 0 0);
  --primary: oklch(0.3458 0.0404 213.11);
  --primary-foreground: oklch(1 0 0);
  --secondary: oklch(0.5436 0.1252 158.9);
  --secondary-hover: oklch(0.58 0.1252 158.9);
  --secondary-bright: oklch(0.7371 0.1689 159.07);
  --secondary-foreground: oklch(1 0 0);
  --muted: oklch(0.97 0 0);
  --muted-foreground: oklch(0.556 0 0);
  --accent: oklch(0.97 0 0);
  --accent-foreground: oklch(0.205 0 0);
  --destructive: oklch(0.577 0.245 27.325);
  --destructive-foreground: oklch(0.577 0.245 27.325);
  --success: oklch(0.65 0.18 145);
  --success-foreground: oklch(0.145 0 0);
  --info: oklch(0.55 0.13 250);
  --info-foreground: oklch(0.145 0 0);
  --warning: oklch(0.65 0.18 60);
  --warning-foreground: oklch(0.145 0 0);
  --border: oklch(0.9373 0.0013 286.37);
  --input: oklch(0.922 0 0);
  --ring: oklch(0.7371 0.1689 159.07);
  --chart-1: oklch(0.646 0.222 41.116);
  --chart-2: oklch(0.6 0.118 184.704);
  --chart-3: oklch(0.398 0.07 227.392);
  --chart-4: oklch(0.828 0.189 84.429);
  --chart-5: oklch(0.769 0.188 70.08);
  --radius: 0.625rem;
  --sidebar: oklch(0.985 0 0);
  --sidebar-foreground: oklch(0.145 0 0);
  --sidebar-primary: oklch(0.205 0 0);
  --sidebar-primary-foreground: oklch(0.985 0 0);
  --sidebar-accent: oklch(0.97 0 0);
  --sidebar-accent-foreground: oklch(0.205 0 0);
  --sidebar-border: oklch(0.922 0 0);
  --sidebar-ring: oklch(0.708 0 0);
  --super-dark-green: oklch(0.3071 0.0409 195.24);
  --mid-grey: oklch(0.7241 0.0037 247.87);
  --semi-dark-grey: oklch(0.4423 0 0);
  --bright-green: oklch(0.7979 0.1692 159.07);
  --ultra-dark-green: oklch(0.1876 0.0089 188.64);
  --dark-green: oklch(0.3735 0.0934 166.69);
  --plain-green: oklch(0.5436 0.1252 158.9);
  --plain-green-a11y: oklch(0.4938 0.1102 159.28);
  --pale-green: oklch(0.9648 0.0811 163.68);
  --white: oklch(1 0 0);
  --signal-red: oklch(0.5514 0.2472 29.23);
  --signal-orange: oklch(0.7451 0.1609 64.42);
  --signal-green: oklch(0.7524 0.1842 142.5);
  --dark-grey: oklch(0.1454 0.0019 264.05);
  --light-grey: oklch(0.9297 0.0012 264.05);
  --off-white: oklch(0.9754 0.0006 264.05);
}
.dark {
  --background: oklch(0.145 0 0);
  --foreground: oklch(0.985 0 0);
  --card: oklch(0.145 0 0);
  --card-foreground: oklch(0.985 0 0);
  --popover: oklch(0.145 0 0);
  --popover-foreground: oklch(0.985 0 0);
  --primary: oklch(0.985 0 0);
  --primary-foreground: oklch(0.205 0 0);
  --secondary: oklch(0.269 0 0);
  --secondary-hover: oklch(0.269 0.1 0);
  --secondary-bright: oklch(0.7371 0.1689 159.07);
  --secondary-foreground: oklch(0.985 0 0);
  --muted: oklch(0.269 0 0);
  --muted-foreground: oklch(0.708 0 0);
  --accent: oklch(0.269 0 0);
  --accent-foreground: oklch(0.985 0 0);
  --destructive: oklch(0.396 0.141 25.723);
  --destructive-foreground: oklch(0.637 0.237 25.331);
  --success: oklch(0.45 0.18 145);
  --success-foreground: oklch(0.985 0 0);
  --info: oklch(0.35 0.13 250);
  --info-foreground: oklch(0.985 0 0);
  --warning: oklch(0.45 0.18 60);
  --warning-foreground: oklch(0.985 0 0);
  --border: oklch(0.269 0 0);
  --input: oklch(0.269 0 0);
  --ring: oklch(0.439 0 0);
  --chart-1: oklch(0.488 0.243 264.376);
  --chart-2: oklch(0.696 0.17 162.48);
  --chart-3: oklch(0.769 0.188 70.08);
  --chart-4: oklch(0.627 0.265 303.9);
  --chart-5: oklch(0.645 0.246 16.439);
  --sidebar: oklch(0.205 0 0);
  --sidebar-foreground: oklch(0.985 0 0);
  --sidebar-primary: oklch(0.488 0.243 264.376);
  --sidebar-primary-foreground: oklch(0.985 0 0);
  --sidebar-accent: oklch(0.269 0 0);
  --sidebar-accent-foreground: oklch(0.985 0 0);
  --sidebar-border: oklch(0.269 0 0);
  --sidebar-ring: oklch(0.439 0 0);
  --super-dark-green: oklch(0.3071 0.0409 195.24);
  --mid-grey: oklch(0.7241 0.0037 247.87);
  --semi-dark-grey: oklch(0.384 0.0017 247.87);
  --bright-green: oklch(0.7979 0.1692 159.07);
  --ultra-dark-green: oklch(0.1876 0.0089 188.64);
  --dark-green: oklch(0.3735 0.0934 166.69);
  --plain-green: oklch(0.5436 0.1252 158.9);
  --plain-green-a11y: oklch(0.4938 0.1102 159.28);
  --pale-green: oklch(0.9648 0.0811 163.68);
  --white: oklch(1 0 0);
  --signal-red: oklch(0.5514 0.2472 29.23);
  --signal-orange: oklch(0.7451 0.1609 64.42);
  --signal-green: oklch(0.7524 0.1842 142.5);
  --dark-grey: oklch(0.1454 0.0019 264.05);
  --light-grey: oklch(0.9297 0.0012 264.05);
  --off-white: oklch(0.9754 0.0006 264.05);
}
@layer base {
  * {
    border-color: var(--border);
    outline-color: var(--ring);
    @supports (color: color-mix(in lab, red, red)) {
      outline-color: color-mix(in oklab, var(--ring) 50%, transparent);
    }
  }
  body {
    background-color: var(--background);
    color: var(--foreground);
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-animation-delay: 0s;
      --tw-animation-direction: normal;
      --tw-animation-duration: initial;
      --tw-animation-fill-mode: none;
      --tw-animation-iteration-count: 1;
      --tw-enter-blur: 0;
      --tw-enter-opacity: 1;
      --tw-enter-rotate: 0;
      --tw-enter-scale: 1;
      --tw-enter-translate-x: 0;
      --tw-enter-translate-y: 0;
      --tw-exit-blur: 0;
      --tw-exit-opacity: 1;
      --tw-exit-rotate: 0;
      --tw-exit-scale: 1;
      --tw-exit-translate-x: 0;
      --tw-exit-translate-y: 0;
    }
  }
}
